import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import api from "../../Utils/api";
import FindStone from "../../Components/Common/FindStone";
import { useStonesContext } from "../../contextFile/StoneContext/StonesContext";
import ImageUploadModalComponent from "../../Components/Common/ImageUploadModalComponent";
import ImageViewerModalComponent from "../../Components/Common/ImageViewerModalComponent";
import AgGridComponent from "../../Components/Common/AgGridComponent";
import {
  PrintStoneSticker,
  PrintBatchSticker,
  PrintStoneStickerFromBatchNo,
} from "../../Utils/commonfunctions";
import { ISOToDateTime, filterParams } from "../../Components/Common/Common";
import Spinner from "react-bootstrap/Spinner";
import { Button, Col, InputGroup, Form } from "react-bootstrap";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import ReactDOM from "react-dom";
import { getCurrentDate, GetPre7DayDate } from "../../Utils/commonfunctions";
import { AttachedFileButton, PrintButton, ViewImageButton } from "../../Components/Common/GridButton";

const emtSearchFormData = {
  start_date: GetPre7DayDate(),
  end_date: getCurrentDate(),
};

export default function Receivewindow() {
  const { listStones, setListStones } = useStonesContext();
  const { setFindNo } = useStonesContext();
  const { setBatchAvgList } = useStonesContext();
  const [receiveFromDepartmentList, setReceiveFromDepartmentList] = useState(
    []
  );

  //Insert Image
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  //Image Viewer
  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);
  const [selectedBatchNo, setSelectedBatchNo] = useState(null);

  //Btn Loader
  const [showLoader, setShowLoader] = useState(false);

  const [stoneDataforPrint, setStoneDataforPrint] = useState([]);

  const [formData, setFormData] = useState(emtSearchFormData);

  const [agGridLoadings, setAgGridLoadings] = useState(false);

  useEffect(() => {
    searchIssueTODepDataDateFilter(emtSearchFormData);
  }, []);

  const receiveStone = () => {
    api
      .post("IssueToDepartment/StoneReceive", listStones)
      .then((result) => {
        toast.success(result.data.message);
        setListStones([]);
        setFindNo("");
        setBatchAvgList([]);
        setShowLoader(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("An error Occurred ");
        setShowLoader(false);
      })
      .finally(() => {
        searchIssueTODepDataDateFilter(emtSearchFormData);
      });
  };

  // Insert Image
  const popUpForImage = (data) => {
    setImageModalOpen(true);
    setModalData(data);
  };

  const closeModal = () => {
    setImageModalOpen(false);
  };
  // Insert Image End

  //Image Viewer Start
  const popUpForViewImage = (batchNo) => {
    setSelectedBatchNo(batchNo);
    setIsImageViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsImageViewerOpen(false);
    setSelectedBatchNo(0);
  };

  // export exel function
  const exportToExcel = () => {
    setShowLoader(true);
    setTimeout(() => {
      const fileName = "RecieveToDepartment.xlsx";

      // Format the data to be exported, including the date and time
      const formattedData = receiveFromDepartmentList.map((item) => {
        const date = new Date(item.createdDatetime);
        const formattedDate = date.toLocaleDateString("en-GB"); // Formats date as dd/mm/yyyy
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedTime = `${hours % 12 || 12
          }:${minutes}:${seconds} ${ampm}`;
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        return {
          Datetime: formattedDateTime,
          stoneNo: item.stoneNo,
          IssueName: item.userNamePrevious,
          IssueDepartmentName: item.departmentNamePrevious,
          UserName: item.userName,
          DepartmentName: item.departmentName,
          pcs: item.pcs,
          Length: item.length,
          Width: item.width,
          Height: item.height,
          Weight: item.weight,
        };
      });

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Department Data");

      // Set up the columns
      worksheet.columns = [
        { header: "Datetime", key: "Datetime", width: 25 },
        { header: "Stone No", key: "stoneNo", width: 15 },
        { header: "Issue Name", key: "IssueName", width: 25 },
        {
          header: "Issue Department Name",
          key: "IssueDepartmentName",
          width: 30,
        },
        { header: "User Name", key: "UserName", width: 25 },
        { header: "Department Name", key: "DepartmentName", width: 25 },
        { header: "PCS", key: "pcs", width: 10 },
        { header: "Length", key: "Length", width: 15 },
        { header: "Width", key: "Width", width: 15 },
        { header: "Height", key: "Height", width: 15 },
        { header: "Weight", key: "Weight", width: 15 },
      ];

      // Add the rows to the worksheet
      worksheet.addRows(formattedData);

      // Style the header row
      const headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF4F81BD" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      // Adjust column widths based on content length
      worksheet.columns.forEach((column) => {
        let maxLength = column.header.length;
        formattedData.forEach((row) => {
          const cellValue = row[column.key];
          if (cellValue) {
            maxLength = Math.max(maxLength, cellValue.toString().length);
          }
        });
        column.width = maxLength + 2; // Add padding
      });

      // Export the Excel file
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName);
      });

      setShowLoader(false);
    }, 1000);
  };

  const onFilterChanged = (event) => {
    // updatePinnedBottomRowData(event);
    // if (event) {
    //   event.api.refreshCells({ force: true, suppressFlash: true });
    // }
    var filteredData = event.api
      .getModel()
      .rowsToDisplay.map((row) => row.data);
    setStoneDataforPrint(filteredData);
  };

  //Print Section Start
  const PrintPreview = ({ stoneDetails }) => {
    return (
      <>
        <div style={{}}>
          <table
            className="table table-bordered"
            style={{
              fontSize: "12px",
              lineHeight: "8px",
              marginTop: "-1px",
              borderColor: "#000",
            }}
          >
            <thead>
              <tr>
                <th
                  colSpan={16}
                  style={{ textAlign: "center", fontSize: "14px" }}
                >
                  Final Stock List
                </th>
              </tr>
              <tr>
                <th style={{ textAlign: "center" }}>No</th>
                <th style={{ textAlign: "left", minWidth: "140px" }}>Date</th>
                <th style={{ textAlign: "center", minWidth: "70px" }}>
                  StoneNo
                </th>
                <th style={{ textAlign: "center" }}>IssueName</th>
                <th style={{ textAlign: "center" }}>IssueDepartmentName</th>
                <th style={{ textAlign: "center" }}>UserName</th>
                <th style={{ textAlign: "center" }}>DepartmentName</th>
                <th style={{ textAlign: "center" }}>PCS</th>
                <th style={{ textAlign: "center" }}>Length</th>
                <th style={{ textAlign: "center" }}>Width</th>
                <th style={{ textAlign: "center" }}>Height</th>
                <th style={{ textAlign: "center" }}>Weight</th>
              </tr>
            </thead>
            <tbody>
              {stoneDetails.map((stone, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "center" }}>{index + 1}</td>
                  <td style={{ textAlign: "left", minWidth: "140px" }}>
                    {ISOToDateTime(stone.createdDatetime)}
                  </td>
                  <td style={{ textAlign: "center", minWidth: "70px" }}>
                    {stone.stoneNo}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {stone.userNamePrevious}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {stone.departmentNamePrevious}
                  </td>
                  <td style={{ textAlign: "center" }}>{stone.userName}</td>
                  <td style={{ textAlign: "center" }}>
                    {stone.departmentName}
                  </td>
                  <td style={{ textAlign: "center" }}>{stone.pcs}</td>
                  <td style={{ textAlign: "center" }}>{stone.length}</td>
                  <td style={{ textAlign: "center" }}>{stone.width}</td>
                  <td style={{ textAlign: "center" }}>{stone.height}</td>
                  <td style={{ textAlign: "center" }}>{stone.weight}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const printissuedepartmentreport = (receiveFromDepartmentList) => {
    const StoneDetailsForPrint = stoneDataforPrint;

    const printWindow = window.open("", "_blank");

    printWindow.document.write(
      '<html><head><title>Print Barcode</title><link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"><style>{{width:"760px;"}}</style></head><body>'
    );

    ReactDOM.render(
      <PrintPreview stoneDetails={StoneDetailsForPrint} />,
      printWindow.document.body
    );

    printWindow.document.write("</body></html>");

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 200);
  };

  const handleCheckboxSelection = (event) => {

    const selectedRows = event.api.getSelectedRows();
    const selectedIssuetodepRow = Array.isArray(selectedRows)
      ? selectedRows
      : [];
    setStoneDataforPrint(selectedIssuetodepRow);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const searchIssueTODepDataDateFilter = () => {
    setAgGridLoadings(true);
    api
      .post(
        `Stone/StoneListOfReceiveFromDepartment?START_DATE=${formData.start_date}&END_DATE=${formData.end_date}`
      )
      .then((response) => {
        setReceiveFromDepartmentList(response.data.data);
        setStoneDataforPrint(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching Jangad data:", error);
      })
      .finally(() => {
        setAgGridLoadings(false);
      });
  };

  const columnDef = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      width: 50,
      headerClass: "centered-header",
      pinned: "left",
    },
    {
      headerName: "Date",
      field: "createdDatetime",
      sortable: true,
      filter: "agDateColumnFilter",
      filterParams: filterParams,
      // headerClass: "widthTableColum",
      width: "200px",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      valueFormatter: (params) => ISOToDateTime(params.value),
    },
    {
      headerName: "No",
      field: "stoneNo",
      sortable: true,
      filter: true,
      // headerClass: "widthTableColum",
      width: "150px",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Issue Name",
      field: "userNamePrevious",
      sortable: true,
      width: "150px",
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Issue Department Name",
      field: "departmentNamePrevious",
      sortable: true,
      width: "150px",
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "User Name",
      field: "userName",
      sortable: true,
      width: "150px",
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Department Name",
      field: "departmentName",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Pcs",
      field: "pcs",
      sortable: true,
      filter: true,
      // headerClass: "widthTableColum",
      width: "100px",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
    },
    {
      headerName: "Length",
      field: "length",
      sortable: true,
      filter: true,
      // headerClass: "widthTableColum",
      width: "100px",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },
    {
      headerName: "Width",
      field: "width",
      sortable: true,
      filter: true,
      // headerClass: "widthTableColum",
      width: "100px",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },
    {
      headerName: "Height",
      field: "height",
      sortable: true,
      filter: true,
      // headerClass: "widthTableColum",
      width: "100px",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },

    {
      headerName: "Weight",
      field: "weight",
      sortable: true,
      filter: true,
      // headerClass: "widthTableColum",
      width: "100px",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellRenderer: ({ value, data }) => value.toFixed(2),
    },
    {
      headerName: "Attached",
      field: "batchNo",
      width: "90",
      cellStyle: { textAlign: "center" },
      headerClass: "center-text widthTableColum",
      cellRenderer: ({ value, data }) => (
        <AttachedFileButton onClickHandler={() => popUpForImage(data)} />
      ),
    },
    {
      headerName: "View",
      field: "batchNo",
      width: "90",
      cellStyle: { textAlign: "center" },
      headerClass: "center-text widthTableColum",
      cellRenderer: ({ value, data }) => (
        <ViewImageButton onClickHandler={() => popUpForViewImage(data.stoneNo)} />
      ),
    },
    {
      headerName: "Print",
      field: "stoneNo",
      width: "90",
      cellStyle: { textAlign: "center" },
      headerClass: "center-text widthTableColum",
      cellRenderer: ({ value, data }) => {
        if (value.split("-")[0] === "LOT") {
          return (
            <PrintButton onClick={() =>
              PrintBatchSticker(data.stoneNo, data.stoneProcessNo)
            } />
          );
        } else {
          return (
            <PrintButton onClickHandler={() => PrintStoneSticker(value, data.stoneProcessNo)} />
          );
        }
      },
    },
    {
      headerName: "StonesByBatch",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      field: "stoneNo",
      width: "90px",
      cellStyle: { textAlign: "center" },
      headerClass: "center-text widthTableColum",
      cellRenderer: ({ value, data }) => {
        if (value.split("-")[0] === "LOT") {
          return (
            <PrintButton onClick={() =>
              PrintStoneStickerFromBatchNo(data.stoneNo, data.stoneProcessNo)
            } />
          );
        } else {
          return (
            <p>
              {" "}
              <b>Not!</b>
            </p>
          );
        }
      },
    },
  ];

  return (
    <>
      {showLoader && (
        <>
          <div className="overlay"></div>
          <div className="overlay-content text-center">
            <Spinner animation="" variant="primary">
              <span class="loader"></span>
            </Spinner>
          </div>
        </>
      )}
      <ToastContainer />
      <FindStone
        IssueTo={"Receieve Stone"}
        findUrlForStone={
          "IssueToDepartment/ByBatchNoOrSotneNoForCueerntUser?BatchNoOrStoneNo"
        }
        findUrlForBatch={
          "IssueToDepartment/BatchAvgListByBatchNoOrStoneNo?BatchNoOrStoneNo"
        }
        showPartNo={false}
        showWithoutTextBox={true}
        showWithTextBox={false}
        showDLCAndLOSS={true}
        showTotal={false}
      />
      <div className="card text-center">
        <div className="card-body d-flex justify-content-center ">
          <button
            type="button"
            className="align-items-center btn btn-primary"
            onClick={receiveStone}
            loading={showLoader}
            disabled={showLoader}
          >
            Save
          </button>
        </div>
      </div>

      <div className="card mt-10">
        <div className="card-header d-flex justify-content-between">
          <div className="fw-bold">
            <span>ReceiveTo Department</span>
          </div>
          <div className="d-flex justify-content-center flex-grow-1">
            <Col md={6} lg={3} sm={12} className="my-0.5">
              <InputGroup className="PolicySelectDateInputGroup">
                <InputGroup.Text id="basic-addon1">From</InputGroup.Text>
                <Form.Control
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleInputChange}
                  required
                />
              </InputGroup>
            </Col>
            <Col md={6} lg={3} sm={12} className="my-0.5 mx-2">
              <InputGroup className="PolicySelectDateInputGroup">
                <InputGroup.Text id="basic-addon1">To</InputGroup.Text>
                <Form.Control
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleInputChange}
                  required
                />
              </InputGroup>
            </Col>
            <Button
              variant="primary"
              onClick={() => searchIssueTODepDataDateFilter()}
            >
              <i className="fa fa-search"></i> Search
            </Button>
          </div>
          <div>
            <Button
              type="button"
              variant="success"
              className="btn btn-primary"
              style={{ marginRight: "10px" }}
              onClick={exportToExcel}
            >
              <i className="fa fa-file-excel"></i> Export to Excel
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                printissuedepartmentreport(receiveFromDepartmentList)
              }
            >
              <i class="fa fa-print"></i> Print
            </Button>
          </div>
        </div>
        <div className="card-body">
          <AgGridComponent
            rowData={receiveFromDepartmentList}
            onSelectionChanged={handleCheckboxSelection}
            columnDefs={columnDef}
            onGridReady={(params) => {
              params.api.sizeColumnsToFit();
            }}
            onFilterChanged={onFilterChanged}
            paginationPageSize={100}
            height="70vh"
            loading={agGridLoadings}
          />
        </div>
      </div>
      {/* Insert Image */}
      {imageModalOpen && (
        <ImageUploadModalComponent
          showModal={imageModalOpen}
          onClose={closeModal} // Pass the function to close the modal
          bNO={modalData.stoneNo}
          sNO={modalData.stoneNo}
          referenceID={modalData.stoneID}
          type="Machine Start"
        />
      )}

      {/* Image Viewer */}
      {isImageViewerOpen && (
        <ImageViewerModalComponent
          showModal={isImageViewerOpen}
          onClose={closeImageViewer}
          referenceID={selectedBatchNo}
          refType="Machine Start"
        />
      )}
    </>
  );
}
